import {
  FooterWrapper,
  PagesNavigationSection,
  LeftArrow,
  RightArrow,
  CurrentPage,
  Separator,
  TotalPages,
} from './MyTicketsTabFooter.styled';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';

export const MyTicketsTabFooter = () => {
  const {
    currentPageNumber,
    totalPagesNumber,
    handleNextPageNumber,
    handlePrevPageNumber,
  } = useServiceDeskContext();
  return (
    <FooterWrapper>
      <PagesNavigationSection>
        <LeftArrow
          className={currentPageNumber === 1 && 'disableLeft'}
          onClick={handlePrevPageNumber}
        />
        <CurrentPage>{currentPageNumber}</CurrentPage>
        <Separator>/</Separator>
        <TotalPages>{totalPagesNumber}</TotalPages>
        <RightArrow
          className={currentPageNumber === totalPagesNumber && 'disableRight'}
          onClick={handleNextPageNumber}
        />
      </PagesNavigationSection>
    </FooterWrapper>
  );
};
